import { useMemo } from "react"
import { CodedDataType } from '../../../../tables'
import { PagesPDFWrapper } from './pagesPDFWrapper'
import { toList } from '../../../../utils/listUtils'
import { Item } from "../../../../modules/operations"

type Props = {
    id: string
    dataType?: CodedDataType
    items: Item[]
    previewMode?: boolean
    firstPageMaxItems?: number
    pageMaxItems?: number
    reserveLastPageSpace?: boolean
    renderPDFPage: (
        pageIndex: number,
        dataType: CodedDataType,
        items: Item[],
        pagesAmount: number
    ) => JSX.Element
}

export const ItemsPDFWrapper = (props: Props) => {
    const { id, dataType, items, previewMode, firstPageMaxItems = 10, pageMaxItems = 13, reserveLastPageSpace = true, renderPDFPage } = props

    const getPagesItems = (dataTypeItems: Item[]) => {
        const pages: Item[][] = []
        const pushPages = (startIndex = 0) => {
            const isFirstPage = startIndex === 0
            const items = dataTypeItems.slice(startIndex)
            if (items.length > 0) {
                const maxPageSize = isFirstPage ? firstPageMaxItems : pageMaxItems
                // La última página deja lugar para los totales que algunos PDFs muestran debajo de la tabla.
                const pageSize = !reserveLastPageSpace ? maxPageSize :
                    items.length < maxPageSize ? maxPageSize - 2 : (items.length === maxPageSize ? maxPageSize - 1 : maxPageSize)
                pages.push(items.slice(0, pageSize))
                pushPages(startIndex + pageSize)
            }
        }
        pushPages()
        
        return pages
    }

    const pagesItems: Item[][] = useMemo(() => getPagesItems(items), [items])

    const renderPages = pagesItems.length > 0 ?
        pagesItems.map(pageItems =>
            (index: number, itemDataType: CodedDataType) => renderPDFPage(index, itemDataType, pageItems, pagesItems.length)
        ) :
        toList((_: number, itemDataType: CodedDataType) => renderPDFPage(0, itemDataType, [], 1))

    return <PagesPDFWrapper
        id={id}
        dataType={dataType!}
        previewMode={previewMode}
        renderPages={renderPages}
    />
}
